// All site content lives here so products, brands and company
// information can be updated without touching presentation components.
//
// NOTE: BRAND_SLOTS and PRODUCT_SLOTS are intentional placeholders.
// Replace their entries with real brand/product data when supplied.

const u = (id, w) =>
  `https://images.unsplash.com/${id}?q=80&auto=format&fit=crop&w=${w}`;

export const IMAGES = {
  heroMain: u("photo-1540555700478-4be289fbecef", 1100),
  heroSecondary: u("photo-1620916297397-a4a5402a3c6c", 680),
  brand1: u("photo-1631729371254-42c2892f0e6e", 900),
  brand2: u("photo-1617897903246-719242758050", 900),
  brand3: u("photo-1620916297397-a4a5402a3c6c", 900),
  product1: u("photo-1617897903246-719242758050", 1200),
  product2: u("photo-1620916297397-a4a5402a3c6c", 1200),
  product3: u("photo-1540555700478-4be289fbecef", 1200),
  company: u("photo-1616394584738-fc6e612e71b9", 1100),
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Brands", id: "brands" },
  { label: "Categories", id: "categories" },
  { label: "Products", id: "products" },
  { label: "Company", id: "company" },
  { label: "Contact", id: "contact" },
];

export const COMPANY = {
  name: "OSWAL COSLABS PRIVATE LIMITED",
  description:
    "OSWAL COSLABS PRIVATE LIMITED is a cosmetic and personal care company focused on skincare, beauty, and baby care products. We aim to provide quality products at affordable prices while maintaining customer trust and satisfaction.",
};

export const ABOUT_STATEMENTS = [
  {
    n: "01",
    text: "We provide quality beauty and cosmetic products at affordable prices.",
  },
  {
    n: "02",
    text: "Our goal is to help customers look and feel beautiful with products they can trust.",
  },
  {
    n: "03",
    text: "Customer satisfaction is our priority.",
  },
];

export const CATEGORIES = [
  { n: "01", name: "SKINCARE", desc: "Everyday essentials for healthy-looking skin." },
  { n: "02", name: "SERUMS", desc: "Focused care with lightweight, modern formulas." },
  { n: "03", name: "MOISTURISERS", desc: "Comforting hydration for daily skin support." },
  { n: "04", name: "CLEANSERS", desc: "Gentle, effective cleansing for a fresh start." },
  { n: "05", name: "SUNSCREENS", desc: "Daily protection designed for modern routines." },
  { n: "06", name: "LIP CARE", desc: "Nourishing care for soft, comfortable lips." },
  { n: "07", name: "BODY CARE", desc: "Head-to-toe care supporting everyday wellbeing." },
  { n: "08", name: "NUTRACEUTICALS", desc: "Wellness solutions designed for life from within." },
  { n: "09", name: "BABY CARE", desc: "Gentle essentials created for delicate care." },
];

// Placeholder slots — replace with real brand data when supplied.
export const BRAND_SLOTS = [
  { n: "01", label: "Brand 01", image: "brand1" },
  { n: "02", label: "Brand 02", image: "brand2" },
  { n: "03", label: "Brand 03", image: "brand3" },
];

// Placeholder slots — replace name/category/description/image per product
// when the actual range is supplied.
export const PRODUCT_SLOTS = [
  {
    n: "01",
    category: "Skincare",
    name: "Product name — coming soon",
    description:
      "A considered skincare essential from our upcoming range. Full product details will be added here.",
    image: "product1",
  },
  {
    n: "02",
    category: "Serums",
    name: "Product name — coming soon",
    description:
      "A lightweight, modern formula in development. Full product details will be added here.",
    image: "product2",
  },
  {
    n: "03",
    category: "Baby Care",
    name: "Product name — coming soon",
    description:
      "A gentle essential created for delicate care. Full product details will be added here.",
    image: "product3",
  },
];

export const WHY_OSWAL = [
  {
    n: "01",
    title: "QUALITY",
    text: "Providing quality beauty and cosmetic products.",
  },
  {
    n: "02",
    title: "AFFORDABILITY",
    text: "Making quality products accessible at affordable prices.",
  },
  {
    n: "03",
    title: "TRUST",
    text: "Building customer confidence through products people can trust.",
  },
  {
    n: "04",
    title: "CUSTOMER SATISFACTION",
    text: "Keeping customer satisfaction at the heart of the company.",
  },
];

export const COMPANY_FACTS = [
  { label: "Company", value: "OSWAL COSLABS PRIVATE LIMITED" },
  { label: "Focus", value: "Skincare · Beauty · Baby Care" },
  { label: "Commitment", value: "Quality products at affordable prices" },
  { label: "Head Office", value: "Ahmedabad, Gujarat, India" },
];

export const CONTACT = {
  email: "info@oswalcoslabs.com",
  officeLines: [
    "1001-A, Premium House,",
    "Opp. Gandhi Gram Railway Station,",
    "Ellis Bridge,",
    "Ahmedabad, Gujarat – 380006",
  ],
};

export const MARQUEE_WORDS = [
  "QUALITY",
  "AFFORDABILITY",
  "TRUST",
  "SATISFACTION",
  "BEAUTY & CARE",
];

export const FOOTER_BLURB =
  "Quality beauty and cosmetic products with a focus on skincare, personal care and baby care.";
